import { render, staticRenderFns } from "./EditWell.vue?vue&type=template&id=add15a16"
import script from "./EditWell.vue?vue&type=script&lang=js"
export * from "./EditWell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports